function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState } from 'react';
import classnames from 'classnames';
import { Breakpoint } from "../../Responsive/Breakpoint/Breakpoint";
import { Button } from "../../Button/Button/Button";
import Colors from "../../Color/Colors";
import { Container } from "../../Container/Container/Container";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Icon } from "../../Icon/Icon/Icon";
import { MatchHeight } from "../../Utility/MatchHeight/MatchHeight";
import { PlanSquare } from "../../Square/PlanSquare/PlanSquare";
import { ScrollTracking } from "../../ScrollTracking/ScrollTracking";
import { StickyBar } from "../../Bar/StickyBar/StickyBar";
import { Text } from "../../Text/Text/Text";
import { Theme } from "../../Background/Theme/Theme";
import { SliceIntroBlock } from "../../Block/SliceIntroBlock/SliceIntroBlock";
import styles from "./PlansDifferentiatorSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var columnNumber;
export var PlansDifferentiatorSlice = function PlansDifferentiatorSlice(_ref) {
  var plans = _ref.plans,
    features = _ref.features,
    plansFootnote = _ref.plansFootnote,
    _ref$screenReaderAvai = _ref.screenReaderAvailable,
    screenReaderAvailable = _ref$screenReaderAvai === void 0 ? 'available for' : _ref$screenReaderAvai,
    _ref$screenReaderNotA = _ref.screenReaderNotAvailable,
    screenReaderNotAvailable = _ref$screenReaderNotA === void 0 ? 'not available for' : _ref$screenReaderNotA,
    _ref$enforceDesktop = _ref.enforceDesktop,
    enforceDesktop = _ref$enforceDesktop === void 0 ? false : _ref$enforceDesktop,
    intro = _ref.intro,
    columnTitles = _ref.columnTitles;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    floatBar = _useState2[0],
    setFloatBar = _useState2[1];
  var screenReaderIconLabel = function screenReaderIconLabel(feature, plan, available) {
    var isAvailable = available ? screenReaderAvailable : screenReaderNotAvailable;
    return "".concat(feature.name, " ").concat(isAvailable, " ").concat(plan.title);
  };
  var renderBarButton = function renderBarButton(cta) {
    return /*#__PURE__*/_jsxs(Breakpoint, {
      breakpoint: "medium",
      children: [/*#__PURE__*/_jsx(Button, {
        type: "secondary",
        url: cta === null || cta === void 0 ? void 0 : cta.url,
        className: styles.barButton,
        size: "small",
        children: cta === null || cta === void 0 ? void 0 : cta.text
      }), /*#__PURE__*/_jsx(Button, {
        type: "secondary",
        url: cta === null || cta === void 0 ? void 0 : cta.url,
        className: styles.barButton,
        size: "large",
        children: cta === null || cta === void 0 ? void 0 : cta.text
      })]
    });
  };
  var renderBar = function renderBar() {
    return /*#__PURE__*/_jsx(Theme, {
      theme: "lightBackground",
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx("div", {
          className: styles.barWrapper,
          children: /*#__PURE__*/_jsxs(Breakpoint, {
            breakpoint: "xl",
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.row,
              children: plans.map(function (plan, key) {
                var cta = plan.cta;
                return cta !== null && cta !== void 0 && cta.url && cta.text ? /*#__PURE__*/_jsx("div", {
                  className: classnames(styles.rowItem, styles.barButtonWrapper),
                  children: renderBarButton(cta)
                }, key) : /*#__PURE__*/_jsx("div", {}, key);
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.row,
              children: [/*#__PURE__*/_jsx("div", {
                className: classnames(styles.rowItem, styles.barButtonWrapper)
              }), plans.map(function (plan, key) {
                var cta = plan.cta;
                return cta !== null && cta !== void 0 && cta.url && cta.text ? /*#__PURE__*/_jsx("div", {
                  className: classnames(styles.rowItem, styles.barButtonWrapper),
                  children: renderBarButton(cta)
                }, key) : /*#__PURE__*/_jsx("div", {}, key);
              })]
            })]
          })
        })
      })
    });
  };
  var renderPlanBlock = function renderPlanBlock() {
    return plans === null || plans === void 0 ? void 0 : plans.map(function (plan, key) {
      return /*#__PURE__*/_jsx("div", {
        className: classnames({
          [styles.rowItem]: true,
          [styles.rowItemFirst]: !!plan.flag
        }),
        children: /*#__PURE__*/_jsx(PlanSquare, _objectSpread(_objectSpread({}, plan), {}, {
          first: key === 0
        }))
      }, key);
    });
  };
  var renderTitleBlock = function renderTitleBlock() {
    return columnTitles === null || columnTitles === void 0 ? void 0 : columnTitles.map(function (title, key) {
      if (title.flag) {
        columnNumber = key;
      }
      return /*#__PURE__*/_jsxs("div", {
        className: classnames(styles.rowItem, styles.columnTitle, {
          [styles.flagColumn]: enforceDesktop && title.flag
        }),
        children: [title.flag !== null ? /*#__PURE__*/_jsx("div", {
          className: styles.flagStyle,
          children: /*#__PURE__*/_jsx(Text, {
            className: styles.flagColor,
            typog: "eyebrow2",
            children: title.flag
          })
        }) : null, /*#__PURE__*/_jsx("div", {
          className: styles.titleStyle,
          children: /*#__PURE__*/_jsx(Text, {
            typog: "subhead2",
            children: title.title
          })
        })]
      }, key);
    });
  };
  var renderComp = function renderComp(feature, plans) {
    var status = feature.status;
    return status === null || status === void 0 ? void 0 : status.map(function (item, key) {
      var color = item === true ? Colors.colorWW100 : Colors.colorWW740;
      var type = item === true ? 'checkmark' : 'blank-x';
      return /*#__PURE__*/_jsxs("div", {
        className: classnames(styles.rowItem, styles.table, {
          [styles.flagColumn]: enforceDesktop && key === columnNumber - 1
        }),
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.sr,
          children: screenReaderIconLabel(feature, plans[key], item)
        }), /*#__PURE__*/_jsx("div", {
          className: classnames(styles.checkmark, enforceDesktop === true && type === 'blank-x' ? styles.hideXIcon : null),
          children: /*#__PURE__*/_jsx(Icon, {
            width: type === 'checkmark' ? '16px' : '14px',
            height: type === 'checkmark' ? '16px' : '14px',
            fill: color,
            type: type
          })
        }, key)]
      }, key);
    });
  };
  var renderTable = function renderTable() {
    return features === null || features === void 0 ? void 0 : features.map(function (feature, key) {
      return /*#__PURE__*/_jsxs("div", {
        className: classnames(styles.rowWrapper, key % 2 !== 0 && !enforceDesktop ? styles.rowWrapperEven : null, key === 0 && styles.rowWrapperFirst, key === features.length - 1 && enforceDesktop ? styles.rowWrapperLast : null),
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.textWrapper,
          children: /*#__PURE__*/_jsxs(Breakpoint, {
            breakpoint: "xl",
            children: [/* Mobile */
            enforceDesktop === false ? /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(Theme, {
                theme: "lightBackground",
                children: /*#__PURE__*/_jsx(HeadingText, {
                  typog: "subhead2",
                  ariaLevel: 3,
                  className: styles.text,
                  children: feature.name
                })
              })
            }) : /*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx("div", {})]
          })
        }), /*#__PURE__*/_jsxs(Breakpoint, {
          breakpoint: "xl",
          children: [/* Mobile */
          !enforceDesktop ? /*#__PURE__*/_jsx("div", {
            className: styles.row,
            children: renderComp(feature, plans)
          }) : /*#__PURE__*/_jsxs("div", {
            className: styles.row,
            children: [/*#__PURE__*/_jsx("div", {
              className: classnames(styles.rowItem, styles.table),
              children: /*#__PURE__*/_jsx(Theme, {
                theme: "lightBackground",
                children: /*#__PURE__*/_jsx(HeadingText, {
                  typog: "subhead2",
                  ariaLevel: 3,
                  className: classnames(styles.text, 'sidebarText'),
                  children: feature.name
                })
              })
            }), renderComp(feature, plans)]
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.row,
            children: [/*#__PURE__*/_jsx("div", {
              className: classnames({
                [styles.rowItem]: true,
                [styles.table]: true
              }),
              children: /*#__PURE__*/_jsx(Theme, {
                theme: "lightBackground",
                children: /*#__PURE__*/_jsx(HeadingText, {
                  typog: "subhead2",
                  ariaLevel: 3,
                  className: classnames(styles.text, 'sidebarText'),
                  children: feature.name
                })
              })
            }), renderComp(feature, plans)]
          })]
        })]
      }, key);
    });
  };
  var showBar = plans === null || plans === void 0 ? void 0 : plans.some(function (plan) {
    var _plan$cta, _plan$cta2;
    return !enforceDesktop ? (plan === null || plan === void 0 ? void 0 : (_plan$cta = plan.cta) === null || _plan$cta === void 0 ? void 0 : _plan$cta.text) && (plan === null || plan === void 0 ? void 0 : (_plan$cta2 = plan.cta) === null || _plan$cta2 === void 0 ? void 0 : _plan$cta2.url) : null;
  });
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.wrapper, enforceDesktop ? styles.enforceDesktop : null),
    children: [enforceDesktop ? /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(SliceIntroBlock, _objectSpread({}, intro))
      })
    }) : null, /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(ScrollTracking, {
        onHide: function onHide() {
          return setFloatBar(true);
        },
        onShow: function onShow() {
          return setFloatBar(false);
        },
        children: /*#__PURE__*/_jsx("div", {
          className: styles.plansWrapper,
          children: /*#__PURE__*/_jsx(MatchHeight, {
            children: /*#__PURE__*/_jsxs(Breakpoint, {
              breakpoint: "xl",
              children: [/*#__PURE__*/_jsx("div", {
                className: classnames(styles.row, styles.rowResize),
                children: !enforceDesktop ? renderPlanBlock() : renderTitleBlock()
              }), /*#__PURE__*/_jsxs("div", {
                className: classnames(styles.row, styles.rowResize),
                children: [!enforceDesktop ? /*#__PURE__*/_jsx("div", {
                  className: classnames(styles.rowItem)
                }) : null, !enforceDesktop ? renderPlanBlock() : renderTitleBlock()]
              })]
            })
          })
        })
      })
    }), showBar && /*#__PURE__*/_jsx("div", {
      className: styles.inlineBar,
      children: renderBar()
    }), /*#__PURE__*/_jsxs(Container, {
      className: !enforceDesktop ? styles.tableContainer : null,
      children: [/*#__PURE__*/_jsx(ScrollTracking, {
        onHide: function onHide() {
          return setFloatBar(false);
        },
        onShow: function onShow() {
          return setFloatBar(true);
        },
        children: /*#__PURE__*/_jsx("div", {
          children: renderTable()
        })
      }), plansFootnote && /*#__PURE__*/_jsx("div", {
        className: styles.footnote,
        children: /*#__PURE__*/_jsx(Text, {
          typog: "captionSmall",
          richText: true,
          children: plansFootnote
        })
      })]
    }), floatBar && showBar && /*#__PURE__*/_jsx(StickyBar, {
      position: "top",
      className: styles.stickyBar,
      children: renderBar()
    })]
  });
};